export const MEMBERSHIP_STATUSES = [
	"provisional",
	"active",
	"expired",
	"deactivated",
] as const;

export const MEMBERSHIP_EXPIRATION_PHASES = [
	"normal",
	"warning",
	"expired",
	"post_expired",
	"deactivation",
] as const;

export type MembershipStatus = (typeof MEMBERSHIP_STATUSES)[number];
export type MembershipExpirationPhase =
	(typeof MEMBERSHIP_EXPIRATION_PHASES)[number];

export const MEMBERSHIP_STATUS_RICHMENU_MAP: Record<
	MembershipStatus,
	"defaultRM" | "memberRM"
> = {
	provisional: "defaultRM",
	active: "memberRM",
	expired: "defaultRM",
	deactivated: "defaultRM",
};

export const MEMBERSHIP_REMINDER_KEYS = {
	preExpiry: "membership_pre_expiry",
	expiryDay: "membership_expiry_day",
	postExpiry: "membership_post_expiry",
	deactivation: "membership_deactivation",
} as const;

export type MembershipReminderKey =
	(typeof MEMBERSHIP_REMINDER_KEYS)[keyof typeof MEMBERSHIP_REMINDER_KEYS];
